import { css, styled } from 'next-yak';
import { StyledButtonProps } from './types';
import Link from 'next/link';

const sharedStyle = css`
  border-style: solid;
  border-width: 2px;
  border-radius: 4.2rem;
  cursor: pointer;
  font-family: var(--font_body);
  font-size: 1.4rem;
  font-weight: 600;
  transition: all 0.6s ease 0s;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const primaryStyle = css`
  background-color: var(--btn_dark);
  border-color: var(--btn_dark);
  box-shadow: var(--btn_shadow);
  color: var(--white);

  &:hover {
    background-color: var(--secondary_400);
    border-color: var(--secondary_400);
    color: var(--text_dark);
  }

  &:active, &:focus {
    box-shadow: var(--shadow_xs_focused);
  }
`;

const secondaryStyle = css`
  background-color: var(--white);
  border-color: var(--text_dark);
  box-shadow: var(--btn_shadow);
  color: var(--text_dark);

  &:hover {
    background-color: var(--secondary_400);
  }

  &:active, &:focus {
    box-shadow: var(--shadow_xs_focused);
  }
`;

export const StyledButton = styled.button<StyledButtonProps>`
  ${sharedStyle};
  padding: ${({ square }) => square ? '0' : '0 2.4rem'};

  height: 4.8rem;
  min-width: ${({ square }) => square ? '4rem' : '16rem'};
  width: ${({ width }) => width ? width : 'auto'};

  ${({ variant }) => variant === 'primary' && primaryStyle};
  ${({ variant }) => variant === 'secondary' && secondaryStyle};
`;

export const StyledButtonNextLink = styled(Link)<StyledButtonProps>`
  ${sharedStyle};
  padding: ${({ square }) => square ? '0' : '0 2.4rem'};

  height: 4.8rem;
  min-width: ${({ square }) => square ? '4rem' : '16rem'};
  width: ${({ width }) => width ? width : 'auto'};

  ${({ variant }) => variant === 'primary' && primaryStyle};
  ${({ variant }) => variant === 'secondary' && secondaryStyle};
`;

export const StyledButtonLink = styled.a<StyledButtonProps>`
  ${sharedStyle};
  padding: ${({ square }) => square ? '0' : '0 2.4rem'};

  height: 4.8rem;
  min-width: ${({ square }) => square ? '4rem' : '16rem'};
  width: ${({ width }) => width ? width : 'auto'};

  ${({ variant }) => variant === 'primary' && primaryStyle};
  ${({ variant }) => variant === 'secondary' && secondaryStyle};
`;